<template>
    <div :class="{modal: true, open: display_modal_name}" v-if="menu_mode !== CONST.MENU_MODE_CLIPPING">
        <div @click.self="closeModal">
            <template v-if="display_modal_name">
                <!--モーダルを閉じた時にコンポーネントごと破棄したいのでv-ifしてます-->
                <ModalContent @close="closeModal"/>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState } from 'vuex'
    import ModalContent from './ModalContent'
    import CONST from "../../assets/js/const";

    export default {
        name: "Modal",
        components: {ModalContent},
        computed: {
            ...mapState(['display_modal_name']),
            ...mapState(["menu_mode"]),
        },
        data: () => ({
            CONST
        }),
        watch: {
            'display_modal_name': name => document.body.style.overflow = name ? 'hidden' : 'auto'
        },
        methods: {
            ...mapMutations(["setModal"]),
            closeModal() { this.setModal('');}
        }
    }
</script>

<style scoped lang="scss">
    .modal{
        display: block;
        position: absolute;
        overflow: hidden;
        z-index: 99;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        visibility: hidden;
        transition: 0.3s;
        &.open{
            opacity: 1;
            visibility: visible;
            overflow: auto;
        }
        > div{
            width: 100%;
            margin: auto;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    @media (min-width: 1500px){
        .modal {
            max-width: 1500px;
        }
     }
    @media screen and (max-width:560px) {
        .modal{
            > div{
            }
        }
    }
</style>
